export default (packageids, statusSerie, numericSerie) => {
  const templateName = getTemplate(packageids);
  if (!templateName) {
    //when no template found will load series to be used with default layout
    return {
      dials: numericSerie ? Object.values(numericSerie) : undefined,
      statuses: statusSerie ? Object.values(statusSerie) : undefined,
    };
  }

  const template = TEMPLATE_ELEMENTS[templateName];

  let off = template.offCalc(statusSerie);

  const dials = template.dials.reduce((prev, item) => {
    const row = item === null ? null : { ...numericSerie[item.serie], ...item };
    prev.push(row);
    return prev;
  }, []);

  // Adding check for two stage and 4 stage chillers if sys_3_op_code is undefined that means we are in
  // a two stage chiller and we will need to filter it out
  let removeStageThreeAndFour = false;
  if (
    templateName === 'chiller' &&
    statusSerie[template.twoStageCheck.serieUndefinedWhenOff] !== undefined &&
    statusSerie[template.twoStageCheck.serieUndefinedWhenOff].value === undefined
  )
    removeStageThreeAndFour = true;

  const statuses = Object.values(statusSerie).filter((x) => {
    if (removeStageThreeAndFour === true && template.twoStageCheck.excludeSerie.includes(x.id))
      return false;

    return template.alarms.find((y) => y.serie === x.id) === undefined;
  });

  const alarms = template.alarms
    .filter((alarm) => statusSerie.hasOwnProperty(alarm.serie))
    .map((alarm) => ({
      ...alarm,
      ...statusSerie[alarm.serie],
      inAlarmState: statusSerie[alarm.serie]
        ? statusSerie[alarm.serie].value === alarm.errorState
        : false,
    }));

  dials.forEach((dial) => {
    if (dial && dial.serie) {
      const alarm = alarms.find((alarm) => alarm.relatedSerie === dial.serie);
      dial.inAlarmState = alarm && alarm.inAlarmState;
    }
  });

  return {
    off,
    dials,
    statuses,
    alarms,
    templateName,
  };
};

const getTemplate = (packageIds) => {
  const templateElementTypes = packageIds.reduce((prev, id) => {
    if (PACKAGE_TEMPLATE_MAPPINGS[id]) {
      prev.push(PACKAGE_TEMPLATE_MAPPINGS[id]);
    }
    return prev;
  }, []);

  return templateElementTypes.length > 0 ? templateElementTypes[0] : null;
};

const PACKAGE_TEMPLATE_MAPPINGS = {
  '1888644131362701965': 'power',
  '946425127598293799': 'power',
  '900583554071659341': 'power',
  '1380404070363169353': 'power',
  '940555193043387297': 'power',
  '824466523073544286': 'pump',
  '1027458292986675380': 'fan',
  '1026736337010557713': 'power',
  '1046994433532232327': 'power',
  '1199335482937311645': 'chiller',
  '1295593606043665017': 'chiller',
  '2000670464992609252': 'power',
  '2056796697866010811': 'fan',
  '2042281683352289994': 'pump_m7',
  '1966808143153333206': 'chiller',
  '2395104989652451496': 'pump_m7',
  '2400225736544747560': 'pump_m7',
};

const PUMP = {
  offCalc: (statuses) => offBaseCalc('ctrl_pnl_state', 'Off', statuses),
  dials: [
    {
      title: 'Engine Speed',
      serie: 'eng_speed',
      min: 0,
      max: 2500,
      showMinMax: true,
      disabledWhenOff: true,
    },
    {
      title: 'Oil Pressure',
      serie: 'eng_oil_pr',
      min: 0,
      max: 140,
      showMinMax: true,
      disabledWhenOff: true,
    },
    {
      title: 'Coolant Temp',
      serie: 'eng_coolant_temp',
      min: 0,
      max: 280,
      showMinMax: true,
      disabledWhenOff: true,
    },
    {
      title: 'Engine Load',
      serie: 'eng_load',
      min: 0,
      max: 100,
      showMinMax: true,
      disabledWhenOff: true,
    },
    {
      title: 'Suction',
      serie: 'suct_pr',
      min: -30,
      max: 200,
      showMinMax: true,
      disabledWhenOff: true,
    },
    {
      title: 'Discharge',
      serie: 'dis_pr',
      min: 0,
      max: 300,
      showMinMax: true,
      disabledWhenOff: true,
    },
    {
      title: 'Flow Rate',
      serie: 'flow_rate',
      min: 0,
      max: 10000,
      showMinMax: true,
      disabledWhenOff: true,
    },
    {
      title: 'Battery Voltage',
      serie: 'battery_potential',
      min: 0,
      max: 30,
      showMinMax: true,
      disabledWhenOff: false,
    },
    {
      title: 'Fuel Level',
      serie: 'fuel_level',
      min: 0,
      max: 100,
      showMinMax: true,
      disabledWhenOff: true,
    },
    { title: 'Sump', serie: 'sys_lvl', min: 0, max: 50, showMinMax: true, disabledWhenOff: true },
    {
      title: 'DEF Fluid',
      serie: 'at1_scr_cat_tank_level',
      min: 0,
      max: 100,
      showMinMax: true,
      disabledWhenOff: true,
    },
  ],
  alarms: [
    {
      serie: 'battery_lo_state',
      errorState: 'Alarm',
      relatedSerie: 'battery_potential',
      disabledWhenOff: false,
    },
    { serie: 'canbus_comm_state', errorState: 'Error', disabledWhenOff: true },
    { serie: 'modbus_comm_state', errorState: 'Error', disabledWhenOff: true },
    { serie: 'engine_protect_sd_state', errorState: 'Alarm', disabledWhenOff: true },
  ],
};

const TEMPLATE_ELEMENTS = {
  power: {
    offCalc: (statuses) => offBaseCalc('ctrl_pnl_state', 'Off', statuses),
    dials: [
      {
        title: 'L-L Volts',
        serie: 'gen_avg_ll_rms_voltage',
        min: 0,
        max: 600,
        showMinMax: true,
        disabledWhenOff: true,
      },
      {
        title: 'Avg Current',
        serie: 'gen_avg_ac_rms_current',
        min: 0,
        max: 1,
        showMinMax: false,
        disabledWhenOff: true,
      },
      {
        title: 'Coolant Temp',
        serie: 'eng_coolant_temp',
        min: 0,
        max: 280,
        showMinMax: true,
        disabledWhenOff: true,
      },
      {
        title: 'Power Load',
        serie: 'gen_tot_per_kw',
        min: 0,
        max: 100,
        showMinMax: true,
        disabledWhenOff: true,
      },
      {
        title: 'Oil Pressure',
        serie: 'eng_oil_pr',
        min: 0,
        max: 140,
        showMinMax: true,
        disabledWhenOff: true,
      },
      {
        title: 'Frequency',
        serie: 'gen_avg_ac_frequency',
        min: 0,
        max: 1,
        showMinMax: false,
        disabledWhenOff: true,
      },
      null,
      {
        title: 'Fuel Level',
        serie: 'fuel_level',
        min: 0,
        max: 100,
        showMinMax: true,
        disabledWhenOff: true,
      },
      {
        title: 'DEF Fluid',
        serie: 'at1_scr_cat_tank_level',
        min: 0,
        max: 100,
        showMinMax: true,
        disabledWhenOff: true,
      },
      {
        title: 'Battery Voltage',
        serie: 'battery_potential',
        min: 0,
        max: 30,
        showMinMax: true,
        disabledWhenOff: false,
      },
      null,
    ],
    alarms: [
      { serie: 'canbus_comm_state', errorState: 'Alarm', disabledWhenOff: true },
      { serie: 'modbus_comm_state', errorState: 'Alarm', disabledWhenOff: true },
      {
        serie: 'battery_lo_state',
        errorState: 'Alarm',
        relatedSerie: 'battery_potential',
        disabledWhenOff: false,
      },
      { serie: 'canbus_comm_state', errorState: 'Error', disabledWhenOff: true },
      { serie: 'modbus_comm_state', errorState: 'Error', disabledWhenOff: true },
      { serie: 'check_genset', errorState: 'Alarm', disabledWhenOff: true },
      { serie: 'chrgr_ac_fail', errorState: 'Alarm', disabledWhenOff: true },
      { serie: 'common_state', errorState: 'Alarm', disabledWhenOff: true },
      { serie: 'overcurr_state', errorState: 'Alarm', disabledWhenOff: true },
      { serie: 'overload_state', errorState: 'Alarm', disabledWhenOff: true },
      { serie: 'underfreq_state', errorState: 'Alarm', disabledWhenOff: true },
      { serie: 'voltage_hi_state', errorState: 'Alarm', disabledWhenOff: true },
      { serie: 'voltage_lo_state', errorState: 'Alarm', disabledWhenOff: true },
      { serie: 'emergency_stop_state', errorState: 'Active', disabledWhenOff: true },
      { serie: 'overfreq_state', errorState: 'Alarm', disabledWhenOff: true },
      { serie: 'eng_temp_hi_state', errorState: 'Alarm', disabledWhenOff: true },
      { serie: 'oil_press_lo_state', errorState: 'Alarm', disabledWhenOff: true },
      { serie: 'overspd_state', errorState: 'Alarm', disabledWhenOff: true },
      { serie: 'coolant_level_lo_state', errorState: 'Alarm', disabledWhenOff: true },
      { serie: 'fail_to_sync', errorState: 'Alarm', disabledWhenOff: true },
      { serie: 'close_state', errorState: 'Alarm', disabledWhenOff: true },
      { serie: 'gen_circuit_breaker_trip_state', errorState: 'Yes', disabledWhenOff: true },
      { serie: 'underfreq_state', errorState: 'Alarm', disabledWhenOff: true },
      { serie: 'overfreq_state', errorState: 'Alarm', disabledWhenOff: true },
      { serie: 'voltage_lo_state', errorState: 'Alarm', disabledWhenOff: true },
      { serie: 'voltage_hi_state', errorState: 'Alarm', disabledWhenOff: true },
      { serie: 'overcurr_state', errorState: 'Alarm', disabledWhenOff: true },
      { serie: 'overload_state', errorState: 'Alarm', disabledWhenOff: true },
    ],
  },
  pump: { ...PUMP },
  pump_m7: {
    ...PUMP,
    offCalc: (statuses) => offBaseCalc('dash_pnl_state', 'Off', statuses),
  },
  fan: {
    offCalc: (statuses) => offBaseCalc('ctrl_pnl_state', 'Off', statuses),
    dials: [
      {
        title: 'Supply Temp',
        serie: 'sup_air_temp',
        min: 0,
        max: 350,
        showMinMax: true,
        disabledWhenOff: true,
      },
      {
        title: 'Return Temp',
        serie: 'ret_air_temp',
        min: 0,
        max: 350,
        showMinMax: true,
        disabledWhenOff: true,
      },
      {
        title: 'L-L Volts',
        serie: 'gen_ca_ll_rms_voltage',
        min: 0,
        max: 600,
        showMinMax: true,
        disabledWhenOff: true,
      },
      {
        title: 'Avg Current',
        serie: 'gen_a_ac_rms_current',
        min: 0,
        max: 1,
        showMinMax: false,
        disabledWhenOff: true,
      },
      {
        title: 'Rel. Hum',
        serie: 'rel_hum',
        min: 25,
        max: 100,
        showMinMax: true,
        disabledWhenOff: true,
      },
      {
        title: 'Cool',
        serie: 'cooling_setpoint',
        min: 0,
        max: 0,
        showMinMax: false,
        disabledWhenOff: true,
      },
      { title: 'Set Point' },
      {
        title: 'Heat',
        serie: 'heating_setpoint',
        min: 0,
        max: 0,
        showMinMax: false,
        disabledWhenOff: true,
      },
      {
        title: 'Ambient Temperature',
        serie: 'ambnt_temp',
        min: 0,
        max: 0,
        showMinMax: false,
        disabledWhenOff: false,
      },
      {
        title: 'Battery Voltage',
        serie: 'battery_potential',
        min: 0,
        max: 27,
        showMinMax: true,
        disabledWhenOff: false,
      },
      {
        title: 'Fuel Level',
        serie: 'fuel_level',
        min: 0,
        max: 100,
        showMinMax: true,
        disabledWhenOff: true,
      },
    ],
    alarms: [
      {
        serie: 'battery_lo_state',
        errorState: 'Alarm',
        relatedSerie: 'battery_potential',
        disabledWhenOff: false,
      },
      { serie: 'canbus_comm_state', errorState: 'Error', disabledWhenOff: true },
      { serie: 'modbus_comm_state', errorState: 'Error', disabledWhenOff: true },
    ],
  },
  chiller: {
    offCalc: (statuses) => offBaseCalc('ctrl_pnl_state', 'Off', statuses),
    dials: [
      {
        title: 'Supply Temp',
        serie: 'sup_air_temp',
        min: 0,
        max: 90,
        showMinMax: true,
        disabledWhenOff: true,
      },
      {
        title: 'Return Temp',
        serie: 'ret_air_temp',
        min: 0,
        max: 90,
        showMinMax: true,
        disabledWhenOff: true,
      },
      {
        title: 'L-L Volts',
        serie: 'gen_ca_ll_rms_voltage',
        min: 0,
        max: 600,
        showMinMax: true,
        disabledWhenOff: true,
      },
      {
        title: 'Avg Current',
        serie: 'gen_a_ac_rms_current',
        min: 0,
        max: 1,
        showMinMax: false,
        disabledWhenOff: true,
      },
      {
        title: 'Flow (GPM)',
        serie: 'flow_rate',
        min: 3,
        max: 12000,
        showMinMax: false,
        disabledWhenOff: true,
      },
      {
        title: 'Local',
        serie: 'local_setpoint',
        min: 0,
        max: 0,
        showMinMax: false,
        disabledWhenOff: true,
      },
      { title: 'Set Point' },
      {
        title: 'Remote',
        serie: 'remote_setpoint',
        min: 0,
        max: 0,
        showMinMax: false,
        disabledWhenOff: true,
      },
      {
        title: 'Ambient Temperature',
        serie: 'ambnt_temp',
        min: 0,
        max: 0,
        showMinMax: false,
        disabledWhenOff: false,
      },
      {
        title: 'Battery Voltage',
        serie: 'battery_potential',
        min: 0,
        max: 27,
        showMinMax: true,
        disabledWhenOff: false,
      },
    ],
    alarms: [
      {
        serie: 'battery_lo_state',
        errorState: 'Alarm',
        relatedSerie: 'battery_potential',
        disabledWhenOff: false,
      },
      { serie: 'canbus_comm_state', errorState: 'Error', disabledWhenOff: true },
      { serie: 'modbus_comm_state', errorState: 'Error', disabledWhenOff: true },
    ],
    twoStageCheck: {
      serieUndefinedWhenOff: 'sys_3_op_code',
      excludeSerie: [
        'sys_3_op_code',
        'sys_3_fault_code',
        'sys_4_op_code',
        'sys_4_fault_code',
        'system_3_status',
        'system_4_status',
      ],
    },
  },
};

const offBaseCalc = (datapointId, value, statuses) => {
  const dp = statuses[datapointId];
  return dp ? dp.value === value : true;
};
